// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.transactions-page .transaction-period fieldset {
  gap: 8px;
}
.transactions-page .transaction-period-actions {
  display: flex;
  gap: 10px;
  align-items: center;
  margin-top: 10px;
}
.transactions-page .transaction-period-actions label {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  color: #78849a;
}
.transactions-page .transaction-period-actions select {
  width: 84px;
}
.transactions-page .transaction-period-actions button {
  flex: 1 1;
}
.transactions-page .transaction-summary .compact-heading {
  margin-bottom: 6px;
  flex-wrap: wrap;
  gap: 6px;
}
.transactions-page .transaction-summary .compact-heading small {
  font-size: 11px;
}
.transactions-page .transaction-total {
  display: block;
  font-size: 29px;
  line-height: 1.3;
  letter-spacing: -0.03em;
  overflow-wrap: anywhere;
}
.transactions-page .transaction-summary-metrics {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
  margin-top: 14px;
}
.transactions-page .transaction-summary-metrics > div {
  min-width: 0;
  display: grid;
  gap: 5px;
}
.transactions-page .transaction-summary-metrics span {
  font-size: 10px;
  color: #78849a;
}
.transactions-page .transaction-summary-metrics b {
  font-size: 14px;
  font-variant-numeric: tabular-nums;
  overflow-wrap: anywhere;
}
.transactions-page .transaction-extra {
  margin-top: 10px;
  border-top: 1px solid #edf0f5;
}
.transactions-page .transaction-extra summary {
  color: #78849a;
  font-size: 11px;
}
.transactions-page .transaction-extra > div {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  font-size: 12px;
  padding-bottom: 6px;
}
.transactions-page .transaction-list > .compact-muted {
  font-size: 10px;
}
.transactions-page .transaction-row {
  border-top: 1px solid #edf0f5;
}
.transactions-page .transaction-row summary {
  list-style: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  min-height: 68px;
  gap: 8px;
  padding: 10px 0;
  box-sizing: border-box;
}
.transactions-page .transaction-row summary::-webkit-details-marker {
  display: none;
}
.transactions-page .transaction-row summary > div {
  flex: 1 1;
  min-width: 0;
  display: grid;
  gap: 4px;
}
.transactions-page .transaction-row summary strong {
  font-size: 13px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.transactions-page .transaction-row summary small {
  font-size: 10px;
  color: #78849a;
  line-height: 1.5;
}
.transactions-page .transaction-row summary b {
  font-size: 14px;
  font-variant-numeric: tabular-nums;
  max-width: 40%;
  overflow-wrap: anywhere;
  text-align: right;
}
.transactions-page .transaction-row summary > svg {
  width: 14px;
  height: 14px;
  flex: 0 0 14px;
  color: #78849a;
}
.transactions-page .transaction-row summary .transaction-client-phone {
  font-size: 12px;
  line-height: 1.5;
  color: #44516a;
  font-variant-numeric: tabular-nums;
  overflow-wrap: anywhere;
}
.transactions-page .transaction-row summary .compact-badge {
  justify-self: start;
}
.transactions-page .transaction-row[open] summary > svg {
  transform: rotate(180deg);
}
.transactions-page .transaction-row dl {
  margin: 0 0 12px;
  padding: 12px;
  border-radius: 10px;
  background: #f7f9fc;
  display: grid;
  gap: 8px;
}
.transactions-page .transaction-row dl > div {
  display: grid;
  grid-template-columns: 110px minmax(0, 1fr);
  gap: 8px;
  font-size: 12px;
  line-height: 1.5;
}
.transactions-page .transaction-row dl dt {
  color: #78849a;
}
.transactions-page .transaction-row dl dd {
  margin: 0;
  overflow-wrap: anywhere;
}
.transactions-page .transaction-row dl dd span {
  display: block;
}
.transactions-page .transaction-top h3 {
  margin: 8px 0;
}
.transactions-page .transaction-top-row {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  padding: 10px 0;
  border-top: 1px solid #edf0f5;
  font-size: 12px;
}
.transactions-page .transaction-top-row span {
  min-width: 0;
  overflow-wrap: anywhere;
}
.transactions-page .transaction-top-row small {
  display: block;
  font-size: 10px;
  margin-top: 4px;
}
.transactions-page .transaction-top-row b {
  text-align: right;
  overflow-wrap: anywhere;
  max-width: 45%;
}
@media (max-width: 350px) {
  .transactions-page .transaction-period fieldset {
    grid-template-columns: minmax(0, 1fr);
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/TransactionsPage/transactions.scss"],"names":[],"mappings":"AACwB;EAAW,QAAA;AACnC;AAAE;EAA8B,aAAA;EAAe,SAAA;EAAW,mBAAA;EAAqB,gBAAA;AAM/E;AANiG;EAAQ,aAAA;EAAe,mBAAA;EAAqB,mBAAA;EAAqB,QAAA;EAAU,cAAA;AAa5K;AAb8L;EAAS,WAAA;AAgBvM;AAhBsN;EAAS,SAAA;AAmB/N;AAlBE;EAAwC,kBAAA;EAAoB,eAAA;EAAiB,QAAA;AAuB/E;AAvByF;EAAQ,eAAA;AA0BjG;AAzBE;EAAqB,cAAA;EAAgB,eAAA;EAAiB,gBAAA;EAAkB,uBAAA;EAAwB,uBAAA;AAgClG;AA/BE;EAA+B,aAAA;EAAe,gDAAA;EAAkD,QAAA;EAAU,gBAAA;AAqC5G;AApCI;EAAQ,YAAA;EAAc,aAAA;EAAe,QAAA;AAyCzC;AAzCqD;EAAO,eAAA;EAAiB,cAAA;AA6C7E;AA7C+F;EAAI,eAAA;EAAiB,kCAAA;EAAoC,uBAAA;AAkDxJ;AAhDE;EAAqB,gBAAA;EAAkB,6BAAA;AAoDzC;AApDwE;EAAU,cAAA;EAAgB,eAAA;AAwDlG;AAxDqH;EAAQ,aAAA;EAAe,8BAAA;EAAgC,SAAA;EAAW,eAAA;EAAiB,mBAAA;AA+DxM;AA9DE;EAAqC,eAAA;AAiEvC;AAhEE;EAAmB,6BAAA;AAmErB;AAlEI;EAAU,gBAAA;EAAkB,eAAA;EAAiB,aAAA;EAAe,mBAAA;EAAqB,gBAAA;EAAkB,QAAA;EAAU,eAAA;EAAiB,sBAAA;AA4ElI;AA5E0J;EAA4B,aAAA;AA+EtL;AA9EM;EAAQ,SAAA;EAAS,YAAA;EAAc,aAAA;EAAe,QAAA;AAoFpD;AApFgE;EAAS,eAAA;EAAiB,gBAAA;EAAkB,mBAAA;EAAqB,uBAAA;AA0FjI;AAzFM;EAAQ,eAAA;EAAiB,cAAA;EAAgB,gBAAA;AA8F/C;AA9FmE;EAAI,eAAA;EAAiB,kCAAA;EAAoC,cAAA;EAAgB,uBAAA;EAAyB,iBAAA;AAqGrK;AArG0L;EAAQ,WAAA;EAAa,YAAA;EAAc,cAAA;EAAgB,cAAA;AA2G7O;AA1GM;EAA4B,eAAA;EAAiB,gBAAA;EAAkB,cAAA;EAAgB,kCAAA;EAAoC,uBAAA;AAiHzH;AAhHM;EAAiB,mBAAA;AAmHvB;AAjHI;EAAwB,yBAAA;AAoH5B;AAnHI;EAAK,gBAAA;EAAkB,aAAA;EAAe,mBAAA;EAAqB,mBAAA;EAAqB,aAAA;EAAe,QAAA;AA2HnG;AA3H6G;EAAQ,aAAA;EAAe,2CAAA;EAA6C,QAAA;EAAU,eAAA;EAAiB,gBAAA;AAkI5M;AAlIgO;EAAK,cAAA;AAqIrO;AArIuP;EAAK,SAAA;EAAW,uBAAA;AAyIvQ;AAzIgS;EAAO,cAAA;AA4IvS;AA1IqB;EAAK,aAAA;AA6I1B;AA5IE;EAAuB,aAAA;EAAe,8BAAA;EAAgC,QAAA;EAAU,eAAA;EAAiB,6BAAA;EAA+B,eAAA;AAoJlI;AApJmJ;EAAO,YAAA;EAAc,uBAAA;AAwJxK;AAxJmM;EAAQ,cAAA;EAAgB,eAAA;EAAiB,eAAA;AA6J5O;AA7J+P;EAAI,iBAAA;EAAmB,uBAAA;EAAyB,cAAA;AAkK/S;AAjKE;EAA4B;IAA+B,qCAAA;EAqK3D;AACF","sourcesContent":[".transactions-page {\n  .transaction-period { fieldset { gap: 8px; } }\n  .transaction-period-actions { display: flex; gap: 10px; align-items: center; margin-top: 10px; label { display: flex; flex-direction: row; align-items: center; gap: 8px; color: #78849a; } select { width: 84px; } button { flex: 1; } }\n  .transaction-summary .compact-heading { margin-bottom: 6px; flex-wrap: wrap; gap: 6px; small { font-size: 11px; } }\n  .transaction-total { display: block; font-size: 29px; line-height: 1.3; letter-spacing: -.03em; overflow-wrap: anywhere; }\n  .transaction-summary-metrics { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 8px; margin-top: 14px;\n    > div { min-width: 0; display: grid; gap: 5px; } span { font-size: 10px; color: #78849a; } b { font-size: 14px; font-variant-numeric: tabular-nums; overflow-wrap: anywhere; }\n  }\n  .transaction-extra { margin-top: 10px; border-top: 1px solid #edf0f5; summary { color: #78849a; font-size: 11px; } > div { display: flex; justify-content: space-between; gap: 12px; font-size: 12px; padding-bottom: 6px; } }\n  .transaction-list > .compact-muted { font-size: 10px; }\n  .transaction-row { border-top: 1px solid #edf0f5;\n    summary { list-style: none; cursor: pointer; display: flex; align-items: center; min-height: 68px; gap: 8px; padding: 10px 0; box-sizing: border-box; &::-webkit-details-marker { display: none; }\n      > div { flex: 1; min-width: 0; display: grid; gap: 4px; } strong { font-size: 13px; overflow: hidden; white-space: nowrap; text-overflow: ellipsis; }\n      small { font-size: 10px; color: #78849a; line-height: 1.5; } b { font-size: 14px; font-variant-numeric: tabular-nums; max-width: 40%; overflow-wrap: anywhere; text-align: right; } > svg { width: 14px; height: 14px; flex: 0 0 14px; color: #78849a; }\n      .transaction-client-phone { font-size: 12px; line-height: 1.5; color: #44516a; font-variant-numeric: tabular-nums; overflow-wrap: anywhere; }\n      .compact-badge { justify-self: start; }\n    }\n    &[open] summary > svg { transform: rotate(180deg); }\n    dl { margin: 0 0 12px; padding: 12px; border-radius: 10px; background: #f7f9fc; display: grid; gap: 8px; > div { display: grid; grid-template-columns: 110px minmax(0, 1fr); gap: 8px; font-size: 12px; line-height: 1.5; } dt { color: #78849a; } dd { margin: 0; overflow-wrap: anywhere; span { display: block; } } }\n  }\n  .transaction-top { h3 { margin: 8px 0; } }\n  .transaction-top-row { display: flex; justify-content: space-between; gap: 8px; padding: 10px 0; border-top: 1px solid #edf0f5; font-size: 12px; span { min-width: 0; overflow-wrap: anywhere; } small { display: block; font-size: 10px; margin-top: 4px; } b { text-align: right; overflow-wrap: anywhere; max-width: 45%; } }\n  @media (max-width: 350px) { .transaction-period fieldset { grid-template-columns: minmax(0, 1fr); } }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
